module.exports = __webpack_public_path__ + "media/images/og-bkbb-musub-logo-d23b6719b8133af8ff89cd06b11c0734.jpg";